// 「代導演」小勾選：專案的製作（PM、副手、全站製作）替導演留言、按通過 / 需修改時勾一下，
// 動畫師才分得清這是導演要改的；導演也會收到通知。只是標示，權限不變。
// 誰看得到由呼叫的畫面用 canMarkOnBehalf(projectRole) 決定（導演、動畫師、訪客不給）。
// 留言框、回覆框、需修改視窗、決定列共用；預設不勾，每次送出後回到不勾。

import { ON_BEHALF_HINT, ON_BEHALF_LABEL } from '../lib/review/commentAuthor';
import './OnBehalfCheck.css';

interface Props {
  checked: boolean;
  onChange: (on: boolean) => void;
  /** 旁邊的小字「這是導演的意見，我幫他記下來」（決定列太擠 → 不寫在旁邊，只放在提示裡） */
  showHint?: boolean;
  disabled?: boolean;
  className?: string;
}

export default function OnBehalfCheck({ checked, onChange, showHint = true, disabled, className }: Props) {
  return (
    <label className={`onbehalf${checked ? ' is-on' : ''}${className ? ` ${className}` : ''}`} title={ON_BEHALF_HINT}>
      <input type="checkbox" checked={checked} disabled={disabled} onChange={e => onChange(e.target.checked)} />
      <span className="onbehalf__name">{ON_BEHALF_LABEL}</span>
      {showHint && <span className="onbehalf__hint">{ON_BEHALF_HINT}</span>}
    </label>
  );
}

/** 作者名字旁邊的小標籤（留言串、提示）：「代導演」 */
export function OnBehalfTag() {
  return <span className="onbehalf-tag" title={ON_BEHALF_HINT}>{ON_BEHALF_LABEL}</span>;
}
